import { apiService } from "./api/ApiService";
import { editoService } from "./api/EditoService";

import { leMagService } from "./api/LeMagService";
import metricsService from "./metrics/MetricsService";
import { Token } from "./model/Token";
export * from "./api";
export * from "./crypto";
export * from "./metrics";
export * from "./model";
export * from "./utils";
export * from "./ws";

export { cryptoProvider };
export { apiService };
export { leMagService };
export { metricsService };
export { editoService };

import cryptoProvider from "./crypto";
import { logger, LoggingConfig } from "@blacknut/logging/dist";
import { UserAgent } from "./model/UserAgent";

export type SDKConfig = {
  userAgent: UserAgent;
  endpoint?: string;
  userToken?: Token;
  familyToken?: Token;
  logging?: LoggingConfig;
  locale?: string;
};
export const configure = ({
  userAgent,
  endpoint,
  userToken,
  familyToken,
  logging,
  locale,
}: SDKConfig) => {
  apiService.cleanup();
  if (endpoint) {
    apiService.endpoint = endpoint;

    if (endpoint.match("api.blacknut.com")) {
      metricsService.endpoint = "https://metrics2.blacknut.com";
    } else if (endpoint.match("staging-api")) {
      metricsService.endpoint = "https://staging-metrics2.blacknut.net";
    } else if (endpoint.match("dev-api")) {
      metricsService.endpoint = "https://dev-metrics2.blacknut.net";
    }
  }
  if (userToken) {
    apiService.userToken = userToken;
    metricsService.userToken = userToken;
  }

  if (familyToken) {
    apiService.familyToken = familyToken;
  }

  apiService.userAgent = userAgent;
  metricsService.userAgent = { ...userAgent, apiVersion: "5.0.2" };

  if (logging) {
    logger.configure(logging);
  }

  apiService.locale = locale;
};
